const { parse } = require("postcss");

const _BATTLECHECK = 5000;
const _STARTBATTLE = 1000;
const _FLIP = 1000;

Vue.component('tournament-arena', {
  template: templates.tournamentArena,
  data() {
    return {
      model: {
        hasTournament: false,
        tournament: [],
        bracket1: [],
        bracket2: [],
        hasResults: false,
        queues: [],
        pause: false,
        autofill: false,
        tournamentBattle: false,
        tournamentPlayers: [],
        tournamentWinner: {},
        settings: {},
        message: null,
        champ: {
          confettiCtx: null,
          fireworksCtx: null,
          balloonCtx: null,
          confettiCanvas: {},
          balloonCanvas: {},
          confetti: [],
          balloons: [],
          user: []
        },
        show: {
          users: false,
          move: false,
        },
      }
    }
  },
  created() {
    const c = this;
    c.get();

  },
  computed: {

    alignStart() {
      const c = this
        return {
          'align-items': 'start'
        };
    }
   
  },
  mounted() {
    const c = this;
  
    c.connect();
    c.tournamentCeleb();
    c.getSettings();

  },
  methods: {

    panZOoom(){
      const c = this;
        const element = document.getElementById('panzoom');

        const panzoom = Panzoom(element, {
        });

        // if(parseInt(c.model.tournament.bracket) <= 16){
        //   panzoom.zoom(0.7);
        //   setTimeout(() => panzoom.pan(-300, -120))
        // }
  
        // if(parseInt(c.model.tournament.bracket) == 32){
        //   panzoom.zoom(0.5);
        //   setTimeout(() => panzoom.pan(-714, -192))
        // }
  
        // if(parseInt(c.model.tournament.bracket) == 64){
        //   panzoom.zoom(0.3);
        //   setTimeout(() => panzoom.pan(-1117.45, -206.331))
        // }
  
        // if(parseInt(c.model.tournament.bracket) == 128){
        //   panzoom.zoom(0.271451);
        //   setTimeout(() => panzoom.pan(-1279.51, -272.731))
        // }

        const scrollableContent = document.getElementById('topContainer');
        const parent = element.parentElement;
        parent.addEventListener('wheel', panzoom.zoomWithWheel);
        
        scrollableContent.addEventListener('mouseenter', (e) => {
            panzoom.setOptions({ disableZoom: true });
            parent.removeEventListener('wheel', panzoom.zoomWithWheel);

        });
        
        scrollableContent.addEventListener('mouseleave', () => {

          panzoom.setOptions({ disableZoom: false });
          parent.addEventListener('wheel', panzoom.zoomWithWheel);
        

        });

        c.model.panZoomInstance = panzoom;

        console.log('Panzoom initialized successfully.');
      
    },
    getSettings() {
      const c = this;
      
      let data = {};

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.key}`] = d;
          }
          c.model.settings = data;

          setTimeout(function() {
            c.getSettings();
          }, 30000);
        })
        .catch(function (error) {
          
        });

    },
    
    generatePlayers() {
      const c = this;

      let count = parseInt(c.model.tournament.bracket);

      while (count >= 2) {
        c.model.bracket1.push(new Array(count / 2).fill(null));
        c.model.bracket2.push(new Array(count / 2).fill(null));
        count /= 2;
      }

      // if(parseInt(c.model.tournament.bracket) === 4){
      //   while (count >= 2) {
      //     c.model.rounds.push(count / 2);
      //     count /= 2;
      //   }
      // }
      // else{
      //   while (count > 2) {
      //     c.model.rounds.push(count / 2);
      //     count /= 2;
      //   }
      // }
     
      
    },
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;
        
        try {

          const parsedData = JSON.parse(messageData);
           if(parsedData.channelId === utils.cookies.get('user_id') && parsedData.tournamentId === c.model.tournament.id){
         
            c.model.tournamentPlayers = [];

            if(parseInt(parsedData.round) === 1){
              parsedData.twitchId = parsedData.winnerTwitchId;
              c.model.message = `${c.model.tournament.name} Champion Announcement`
              $('.modal').addClass('is-above').addClass('is-visible');
              // console.log(parsedData);
          
              c.getTwitchInfo(parsedData);
            }
      
            if(parsedData.message === 'tournament_queue'){
              c.getTeamPlayerQUeue();
              c.getPlayerQUeue();
            }
            

            else if(parsedData.message === 'streamer_accept' && parsedData.channelId === utils.cookies.get('channelId')){
    
              c.getTeamPlayerQUeue();
              c.getPlayerQUeue();
            }

            else if(parsedData.message === 'streamer_accept_event' && parsedData.channelId === utils.cookies.get('channelId')){
        
             c.getPlayerQUeue(true);
            }
           
            else{
              setTimeout(function() {
                c.getPlayers(parsedData.tournamentId, false);
              }, 1000)
            }
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }

      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
      const c = this;

      tournamentService.getActive()
      .then((res) => {
     
          c.model.tournament = res.data[0];   
          if(res.data.status===400){
            c.model.hasTournament = false;
          }
          else{
            c.model.hasTournament = true;
            if(res.data[0].battleOption !== 'single'){
              tournamentService.checkTeamTournament(res.data[0].id)
              .then((res) =>{
                c.model.tournamentBattle = true;
                c.getPlayers(res.data.id, false);
              })
              .catch((error) => {
                c.generatePlayers();
                c.getTeamPlayerQUeue();
                c.panZOoom();
      
              })
            }
            else{

              if(c.model.tournament.event_active){

                  tournamentService.tournamentEvent(res.data[0].id)
                  .then((res) =>{
                    c.getPlayers(res.data.id, true);
                  })
                  .catch((error) => {
                    console.log(error)
                    c.generatePlayers();
                    c.getPlayerQUeue(true);
                    c.panZOoom();
                    // console.log(c.model)
          
                  })

              }

              else{


                  tournamentService.checkTournament(res.data[0].id)
                  .then((res) =>{
                    c.model.tournamentBattle = true;
                    c.getPlayers(res.data.id, false);
                  })
                  .catch((error) => {
                    c.generatePlayers();
                    c.getPlayerQUeue(false);
                    c.panZOoom();
                    // console.log(c.model)
          
                  })
              }
            
            }
         
          }
      

      })
      .catch((error) => {
        c.model.hasTournament = false;
        console.log(error);
  
      });
  },
  onDragStart(event,queue,index, bracket){
    const c = this;
    queue.index = index;
    queue.bracket = bracket;
    event.dataTransfer.setData('text/plain', JSON.stringify(queue));

  },
  onDragEnd(){
    const c = this;
  },
  onDrop(event, bracket, index){

    const c = this;

    event.preventDefault();

    const queue = event.dataTransfer.getData('text/plain');

    const parsedData  = JSON.parse(queue);


    if(bracket === 1){

      const foundBracketQueue = c.model.bracket2[0].findIndex(player => player && player.twitchId === parsedData.twitchId);
      const foundBracket2Queue = c.model.bracket1[0].findIndex(player => player && player.twitchId === parsedData.twitchId);

      if(parsedData.index === null){
        parsedData.index = index;

          if(foundBracket2Queue !== -1){
            Vue.set(c.model.bracket1[0], foundBracket2Queue, null);
            Vue.set(c.model.bracket1[0], foundBracket2Queue, c.model.bracket1[0][index]);
          }

          if(foundBracketQueue !== -1){
            Vue.set(c.model.bracket2[0], foundBracketQueue, null);
          }

          Vue.set(c.model.bracket1[0], index, parsedData);
      }
      else{

        if(foundBracket2Queue !== -1){
          Vue.set(c.model.bracket1[0], foundBracket2Queue, null);
          Vue.set(c.model.bracket1[0], foundBracket2Queue, {
              ...c.model.bracket1[0][index], 
              index: foundBracket2Queue 
          });
        }

        if(parsedData.bracket === 2){
          Vue.set(c.model.bracket2[0], parsedData.index, null);
          // Vue.set(c.model.bracket2[0], parsedData.index, c.model.bracket1[0][index]);
          Vue.set(c.model.bracket2[0], parsedData.index, {
              ...c.model.bracket1[0][index], // Copy existing properties
              index: parsedData.index // Set the new index
          });
        }

        if (index >= 0 && index < c.model.bracket1[0].length) {
          Vue.set(c.model.bracket1[0], index, parsedData);
        }
      }
     
    }
    else{
      const foundBracketQueue = c.model.bracket1[0].findIndex(player => player && player.twitchId === parsedData.twitchId);
      const foundBracket2Queue = c.model.bracket2[0].findIndex(player => player && player.twitchId === parsedData.twitchId);
      // console.log(foundBracketQueue)

      if(parsedData.index === null){
        parsedData.index = index;
          if(foundBracket2Queue !== -1){
            Vue.set(c.model.bracket2[0], foundBracket2Queue, null);
            Vue.set(c.model.bracket2[0], foundBracket2Queue, c.model.bracket2[0][index]);
          }
          if(foundBracketQueue !== -1){
            Vue.set(c.model.bracket1[0], foundBracketQueue, null);
          }
          Vue.set(c.model.bracket2[0], index, parsedData);
      }
      else{

        if(foundBracketQueue !== -1){
          Vue.set(c.model.bracket1[0], foundBracket2Queue, null);
          Vue.set(c.model.bracket1[0], foundBracket2Queue, {
              ...c.model.bracket1[0][index], 
              index: foundBracket2Queue 
          });
        }
 
        if(foundBracket2Queue !== -1){
          Vue.set(c.model.bracket2[0], foundBracket2Queue, null);
          Vue.set(c.model.bracket2[0], foundBracket2Queue, {
              ...c.model.bracket2[0][index], 
              index: foundBracket2Queue 
          });
        }

      

        if(parsedData.bracket === 1){
          Vue.set(c.model.bracket1[0], parsedData.index, null);
          // Vue.set(c.model.bracket2[0], parsedData.index, c.model.bracket1[0][index]);
          Vue.set(c.model.bracket1[0], parsedData.index, {
              ...c.model.bracket2[0][index], // Copy existing properties
              index: parsedData.index // Set the new index
          });
        }

        if (index >= 0 && index < c.model.bracket2[0].length) {
          Vue.set(c.model.bracket2[0], index, parsedData);
        }
      }
    }
    
    // console.log(c.model)
  },
  onDragOver(){
    const c = this;
  },
  onDragLeave(){
    const c = this;
  },
  getPlayerQUeue(isEvent) {
    const c = this;

    if(isEvent){

      tournamentService
      .getTournamentEventQueue(c.model.tournament.id)
      .then((res) => {

        // c.model.tournamentBattle = false
        c.model.hasResults = true;
        c.model.queues = res.data;
       
      })
      .catch((err) => {
        c.model.hasResults = false;
      });

      console.log(c.model)
    }
    else{
      tournamentService
      .getTournamentQueue()
      .then((res) => {
        c.model.hasResults = true;
        c.model.queues = res.data;
       
      })
      .catch((err) => {
        c.model.hasResults = false;
      });
    }

    console.log(c.model)
  },
  getTeamPlayerQUeue() {
    const c = this;

    tournamentService
      .getTournamentTeamQueue()
      .then((res) => {
        c.model.hasResults = true;
        c.model.queues = res.data;
       
      })
      .catch((err) => {
        c.model.hasResults = false;
      });
  },
  zoomIn(){
    const c = this;
    c.model.panZoomInstance.zoomIn();
  },
  zoomOut(){
    const c = this;
    c.model.panZoomInstance.zoomOut();
  },
  reset(){
    const c = this;
    c.model.panZoomInstance.reset();
  },
  resumePan(){
    const c = this;

    c.panZOoom();
    c.model.pause = false;
  },
  destroy(){
    const c = this;
    c.model.panZoomInstance.destroy();
    c.model.pause = true;
  },
  autoFill(){
    const c = this;
    c.model.autofill = true;

    if(c.model.tournament.universalFaction){
      c.assignUsersToBrackets(c.model.queues)
    }
    else{
      c.randomBracket();
    }

  },
  autoFillReset(){
    const c = this;

    c.model.autofill = false;

    for(i = 0;i<c.model.bracket1[0].length; i++){
      Vue.set(c.model.bracket2[0], i, null);
      Vue.set(c.model.bracket1[0], i, null);
    }
  },
  randomBracket() {
    const c = this;

    const activeQueues = c.model.queues.filter(queue => queue.active); // Assuming each queue has an 'active' property

    // If there are no active queues, log a message and exit
    if (activeQueues.length === 0) {
        console.warn("No active queues available. Skipping shuffle.");
        c.model.autofill = false;
        return; // Exit the function if there are no active queues
    }

    const shuffledQueues = [...activeQueues]; 
    c.shuffleArray(shuffledQueues);

     // Calculate the lengths of bracket1 and bracket2
     const bracket1Length = c.model.bracket1[0].length;
     const bracket2Length = c.model.bracket2[0].length;
 
     // Determine the maximum number of items we can use
     const maxItems = Math.min(shuffledQueues.length, bracket1Length + bracket2Length);

    const halfLength = Math.floor(maxItems / 2);

    // Split the shuffled array into two halves based on the maximum items
    const firstHalf = shuffledQueues.slice(0, halfLength);
    const secondHalf = shuffledQueues.slice(halfLength, maxItems);

    // Insert the first half into bracket1
    firstHalf.forEach((value, index) => {
      // Add index to the value
      Vue.set(c.model.bracket1[0], index, {
          ...value, // Spread existing properties
          index: index // Add the index property
      });
  });
    // Insert the second half into bracket2
    secondHalf.forEach((value, index) => {
      Vue.set(c.model.bracket2[0], index, {
        ...value, // Spread existing properties
        index: index // Add the index property
    });
    });


    console.log(c.model)

  },
  assignUsersToBrackets(users) {

    const c = this;

    const activeQueues = c.model.queues.filter(queue => queue.active); // Assuming each queue has an 'active' property

    // If there are no active queues, log a message and exit
    if (activeQueues.length === 0) {
        console.warn("No active queues available. Skipping shuffle.");
        c.model.autofill = false;
        return; // Exit the function if there are no active queues
    }

    // Group queues by factionId
    const factionGroups = {};
    activeQueues.forEach(queue => {
        if (!factionGroups[queue.factionId]) {
            factionGroups[queue.factionId] = [];
        }
        factionGroups[queue.factionId].push(queue);
    });

    // Create an array of factions
    const factions = Object.keys(factionGroups);
    const shuffledQueues = [];

    // Alternate adding from each faction group
    let maxLength = Math.max(...Object.values(factionGroups).map(group => group.length));
    for (let i = 0; i < maxLength; i++) {
        factions.forEach(faction => {
            if (factionGroups[faction][i]) {
                shuffledQueues.push(factionGroups[faction][i]);
            }
        });
    }

    // Calculate the lengths of bracket1 and bracket2
    const bracket1Length = c.model.bracket1[0].length;
    const bracket2Length = c.model.bracket2[0].length;

    // Determine the maximum number of items we can use
    const maxItems = Math.min(shuffledQueues.length, bracket1Length + bracket2Length);

    const halfLength = Math.floor(maxItems / 2);

    // Split the shuffled array into two halves based on the maximum items
    const firstHalf = shuffledQueues.slice(0, halfLength);
    const secondHalf = shuffledQueues.slice(halfLength, maxItems);

    // Insert the first half into bracket1
    firstHalf.forEach((value, index) => {
        Vue.set(c.model.bracket1[0], index, {
            ...value, // Spread existing properties
            index: index // Add the index property
        });
    });

    // Insert the second half into bracket2
    secondHalf.forEach((value, index) => {
        Vue.set(c.model.bracket2[0], index, {
            ...value, // Spread existing properties
            index: index // Add the index property
        });
    });

    console.log(c.model);

  },
  shuffleArray(array){
    const c = this;

    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; 
    }
  },
  startTournament(){

    const c = this;

    const bracket1 = c.model.bracket1[0];
    const bracket2 = c.model.bracket2[0];

    if (c.isNullArray(bracket1) || c.isNullArray(bracket2)) {
      utils.alert.error('At least one of the bracket is empty')
    } else {


      let data = {
        bracket1: bracket1,
        bracket2: bracket2,
        tournament: c.model.tournament,
        autobattle: c.model.tournament.auto,
        message: 'battle',
        channelId: utils.cookies.get('user_id')
      }

      if(c.model.tournament.battleOption !== 'single'){
          data.mode = 'team'
      }
      else{
          data.mode = 'single'
      }

        tournamentService
        .saveTournamentBattle(data)
        .then((res) => {
          console.log('tournament started')
          c.model.tournamentBattle = true;
   
          if(c.model.tournament.event_active){
            c.getPlayers(c.model.tournament.id, true);
          }
          else{
            c.getPlayers(c.model.tournament.id, false);
          }
     
        })
        .catch((err) => {
          c.model.hasResults = false;
        });

        c.ws.send(JSON.stringify(data));
 

    }

   
  },
  isNullArray(arr){
    return arr === null || arr.length === 0 || arr.every(item => item === null);
  },
  getPlayers(id, event = false){

    const c = this;
    
    tournamentService.getTournamentPlayer(id, event)
    .then((res) => {

      let players = [];


      const filteredData = res.data.filter(item => item.UserId !== null && item.player !== "");
   
      for(let i = 0; i < filteredData.length; i++){

        const currentRound = parseInt(filteredData[i].round);

        let data = {
          twitchDisplayName: filteredData[i].player,
          twitchId: filteredData[i].UserId,
          cards: filteredData[i].Cards,
          status: filteredData[i].BattleStatus,
          index: filteredData[i].index,
          factionId: filteredData[i].factionId,
          round: filteredData[i].round,
        }

        let index = filteredData[i].index.split(',').map(num => parseInt(num, 10));

        players.push(data);
        if (currentRound === c.model.tournament.round) {


          if (parseInt(filteredData[i].bracket) === 1) {
         
            if(filteredData[i].playerStatus == 'player1'){
              Vue.set(c.model.bracket1[0], index[0], data);
            }
            else{
              Vue.set(c.model.bracket1[0], index[1], data);
            }
        
          }
          else{
            if(filteredData[i].playerStatus == 'player1'){
              Vue.set(c.model.bracket2[0], index[0], data);
            }
            else{
              Vue.set(c.model.bracket2[0], index[1], data);
            }
          }

        }
        else {
         
          const roundIndex = c.model.tournament.round - currentRound; 

          const foundBracketQueue = players.findIndex(player =>  player && parseInt(player.twitchId) == parseInt(filteredData[i].UserId));

          let index = filteredData[i].index.split(',').map(num => parseInt(num, 10));

          if (parseInt(filteredData[i].bracket) === 0) {
            const final = c.model.bracket1.length - 1;
            
            if(filteredData[i].playerStatus == 'player1'){
              Vue.set(c.model.bracket1[final], 0, data);
            }
            else{
              Vue.set(c.model.bracket2[final], 0, data);
            }
            
            if(filteredData[i].BattleStatus === 'Winner'){
               c.model.tournamentWinner = data;
            }
          }
          else if(parseInt(filteredData[i].bracket) === 1){
            if(filteredData[i].playerStatus == 'player1'){
              Vue.set(c.model.bracket1[roundIndex], index[0], data);
            }
            else{
              Vue.set(c.model.bracket1[roundIndex], index[1], data);
            }
          }
          else{
            if(filteredData[i].playerStatus == 'player1'){
              Vue.set(c.model.bracket2[roundIndex], index[0], data);
            }
            else{
              Vue.set(c.model.bracket2[roundIndex], index[1], data);
            }
          }
        }
    

      }
     const playersMap = new Map();

     players.forEach(item => {
      const { twitchId, round } = item;

      if (playersMap.has(twitchId)) {
          const existing = playersMap.get(twitchId);

          if (parseInt(round) < parseInt(existing.round)) {
              playersMap.set(twitchId, item); 
          }
      } else {
          playersMap.set(twitchId, item); 
      }

    });

    const uniquePlayers = Array.from(playersMap.values());

    c.model.tournamentPlayers = uniquePlayers;
    c.model.tournamentBattle = true;

    })
    .error((error) => {
      console.log(error)
    })
  },
  resetModel(){
    const c = this;
    c.model = {
        bracket1: [],
        bracket2: [],
        tournamentPlayers: [],
        tournamentWinner: []
    }
  },
  isEmpty(obj){
    return Object.keys(obj).length === 0;
  },
  confirmChampion(){
    const c = this;

    if(c.model.tournament.event_active){

      let data = {
        champion: c.model.champ.user[0],
        twitchId: utils.cookies.get('user_id'),
        players: c.model.tournamentPlayers,
        eventId: c.model.tournament.eventId,
        tournamentId: c.model.tournament.id,

      }

      tournamentService.confirmChampion(data)
      .then(function(response){
          console.log(response)
      })
      .catch(function(error){

      })

    }


      $('.modal').removeClass('is-above').removeClass('is-visible');
      $('.tournament-champion').addClass('is-above').addClass('is-visible');

      setTimeout(function (){
        c.model.show.users = true;
        setTimeout(function (){
          c.model.show.move = true;
          setTimeout(function(){
            $(`.user-champion-label`).addClass('show')
          },1000)
        },1000)
      },3000)

      c.tournamentCeleb();

  },
  tournamentCeleb(){
    const c = this;

    c.model.champ.confettiCanvas.width = window.innerWidth;
    c.model.champ.confettiCanvas.height = window.innerHeight;
    // fireworksCanvas.value.width = window.innerWidth;
    // fireworksCanvas.value.height = window.innerHeight;
    c.model.champ.balloonCanvas.width = window.innerWidth;
    c.model.champ.balloonCanvas.height = window.innerHeight;
    
    c.createConfetti()
    setTimeout( function(){
      c.createBalloons()
    }, 5000)
   
    
    c.animate()
  //   let fireworks = [];
  //   c.createFirework(x, y);
  //   let balloons = [];
  //   c.createBalloons();
  },
  createConfetti() {
    const c = this;
    const confetti = [];
    const usedPositions = new Set();
  
    for (let i = 0; i < 500; i++) {
      let x, y;
      do {
        x = Math.random() * c.model.champ.confettiCanvas.width;
        y = Math.random() * c.model.champ.confettiCanvas.height - c.model.champ.confettiCanvas.height;
      } while (usedPositions.has(`${x.toFixed(2)},${y.toFixed(2)}`)); // Check if the position is already used
  
      usedPositions.add(`${x.toFixed(2)},${y.toFixed(2)}`); // Add the position to the Set
  
      confetti.push({
        x: x,
        y: y,
        width: Math.random() * 20 + 10,
        height: Math.random() * 10 + 5, 
        color: `hsl(${Math.random() * 360}, 100%, 70%)`,
        tilt: Math.random() * 10 - 5,
        speed: Math.random() * 0.5 + 1,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: Math.random() * 0.05 + 0.02,
        xRotationSpeed: Math.random() * 0.05 + 0.01 // Unique speed for x-axis rotation
      });
    }
  
    c.model.champ.confetti = confetti;
  },
  
  drawConfetti(confettiCtx) {
    const c = this;
    if (!confettiCtx) {
      console.error("Canvas context is undefined");
      return;
    }
    
    // Clear the canvas
    confettiCtx.clearRect(0, 0, c.model.champ.confettiCanvas.width, c.model.champ.confettiCanvas.height);
    
    // Draw each confetti piece
    c.model.champ.confetti.forEach((a) => {
      confettiCtx.fillStyle = a.color; // Set the color for the rectangle
      
      // Save the current context
      confettiCtx.save();
      
      // Move the context to the position of the confetti
      confettiCtx.translate(a.x + a.width / 2, a.y + a.height / 2); // Move to the center of the rectangle
      
      // Rotate around the x-axis (simulated by scaling)
      confettiCtx.scale(1, Math.cos(a.rotation)); // Simulate x-axis rotation
      confettiCtx.rotate(a.rotation); // Rotate the context around the z-axis
      
      // Draw the rectangle centered at (0, 0)
      confettiCtx.fillRect(-a.width / 2, -a.height / 2, a.width, a.height); // Draw rectangle
      
      // Restore the context to its original state
      confettiCtx.restore();
      
      // Update position to fall downwards
      a.y += a.speed; // Move downwards
      a.rotation += a.rotationSpeed; // Increment rotation by rotation speed
      a.rotation += a.xRotationSpeed; // Increment x-axis rotation
  
      // Reset position if it goes off the canvas
      if (a.y > c.model.champ.confettiCanvas.height) {
        a.y = -a.height; // Reset to just above the canvas
        a.x = Math.random() * c.model.champ.confettiCanvas.width; // Optionally randomize x position
      }
    });
  },
  createFirework(x,y){
    for (let i = 0; i < 50; i++) {
      fireworks.push({
        x: x,
        y: y,
        r: Math.random() * 5 + 1,
        color: `hsl(${Math.random() * 360}, 100%, 70%)`,
        vx: Math.random() * 4 - 2,
        vy: Math.random() * 4 - 2,
      });
    }
  },
  drawFireworks() {
    const c = this;
    fireworksCtx.clearRect(0, 0, fireworksCanvas.width, fireworksCanvas.height);
    fireworks.forEach((f, i) => {
      fireworksCtx.beginPath();
      fireworksCtx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      fireworksCtx.fillStyle = f.color;
      fireworksCtx.fill();
      f.x += f.vx;
      f.y += f.vy;
      f.r -= 0.05;
      if (f.r <= 0) fireworks.splice(i, 1);
    });
  },
  createBalloons() {
    const c = this;

    for (let i = 0; i < 30; i++) {
      c.model.champ.balloons.push({
        x: Math.random() * c.model.champ.balloonCanvas.width,
        y: c.model.champ.balloonCanvas.height + Math.random() * 100,
        r: Math.random() * 20 + 10,
        color: `hsl(${Math.random() * 360}, 100%, 70%)`,
        vy: Math.random() * 2 + 1,
      });
    }
  },
  drawBalloons(balloonCtx) {
    const c = this;
    

    balloonCtx.clearRect(0, 0, c.model.champ.balloonCanvas.width, c.model.champ.balloonCanvas.height);
    c.model.champ.balloons.forEach((b, i) => {
      balloonCtx.beginPath();
      balloonCtx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
      balloonCtx.fillStyle = b.color;
      balloonCtx.fill();
      b.y -= b.vy;
      if (b.y + b.r < 0) c.model.champ.balloons.splice(i, 1);
    });
  },
  animate() {

    const c = this;

    const confettiCanvas = document.getElementById('confettiCanvas');
    const fireworksCanvas = document.getElementById('fireworksCanvas');
    const balloonCanvas = document.getElementById('balloonCanvas');
    const confettiCtx = confettiCanvas.getContext('2d');
    const fireworksCtx = fireworksCanvas.getContext('2d');
    const balloonCtx = balloonCanvas.getContext('2d');
    confettiCanvas.width = fireworksCanvas.width = balloonCanvas.width = window.innerWidth;
    confettiCanvas.height = fireworksCanvas.height = balloonCanvas.height = window.innerHeight;
 

    c.drawConfetti(confettiCtx);
    // c.drawFireworks();
    c.drawBalloons(balloonCtx);
    requestAnimationFrame(c.animate.bind(c));
  },
  getTwitchInfo(data) {
    const c = this;

    console.log(data)
    console.log(c.model)

    if(typeof data.winnerTwitchId === 'object'){

      let twitchIds = Array.isArray(data.winnerTwitchId) 
        ? data.winnerTwitchId.map(winner => winner.user.twitchId) 
        : [data.winnerTwitchId];

      let userRequests = twitchIds.map(twitchId => ({ twitchId }));

      twitchAPI.getUsersById(userRequests, function(userData) {
        console.log(userData)
        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }
  
          c.model.champ.user.push(user);

        }
      });
    }
    else{
      twitchAPI.getUsersById([{twitchId: data.winnerTwitchId}], function(userData) {

        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }
  
          c.model.champ.user.push(user);
          
        }
      });
    }


  },

  },
 
})